import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthState } from 'src/shared/state/auth.state';
import { MainMenuButtonComponent } from '../main-menu-button/main-menu-button.component';

@Component({
	selector: 'app-main-menu',
	templateUrl: './main-menu.component.html',
	styleUrls: ['./main-menu.component.scss'],
	imports: [CommonModule, FlexLayoutModule, MainMenuButtonComponent],
})
export class MainMenuComponent {
	private store = inject(Store);

	isAdmin: Observable<boolean> = this.store.select(AuthState.isAdmin);
	isBasicRecords: Observable<boolean> = this.store.select(
		AuthState.isBasicRecords
	);
	isHR: Observable<boolean> = this.store.select(AuthState.isHR);
	isCrisisTeam: Observable<boolean> = this.store.select(
		AuthState.isCrisisTeam
	);
	hasUserResource: Observable<boolean> = this.store.select(
		AuthState.hasUserResource
	);
	isHousing: Observable<boolean> = this.store.select(AuthState.isHousing);
	isReports: Observable<boolean> = this.store.select(AuthState.isReports);
	isApprover: Observable<boolean> = this.store.select(AuthState.isApprover);
	isTravelQueueViewer: Observable<boolean> = this.store.select(
		AuthState.isTravelQueueViewer
	);
	apiUrl: string = environment.apiUrl;

	getSearchLink(): string[] {
		return this.store.selectSnapshot(AuthState.canViewFullUser)
			? ['/tacit/hr/user']
			: ['/tacit/basic/user'];
	}
}
